import $ from 'jquery';
import Registry from '../Registry';

class Popup {

    static initClass() {

        this.prototype.options = {
            css: {
                position: "fixed",
                width: "100%",
                height: "100%",
                top: 0,
                left: 0,
                zIndex: 1050
            }
        };

        this.prototype.html_lang = 'en';
    }

    constructor(opts, widgetType, title=''){
        Registry.d("Popup.constructor");
        this.id = `_etouches_popup_window_${String(Math.random()).replace(".", "")}`;
        for (let x in opts) {
            if (this.options[x]) {
                this.options[x] = $.extend(this.options[x], opts[x]);
            }
        }
        this.content = {};
        this.body = $("body");
        this.widgetType = widgetType;
        this.html_lang = opts.html_lang;

        this.body.append(`
            <iframe 
                class="etouches-${this.widgetType}-popup" 
                id="${this.id}" 
                style='display: none' 
                data-sessionid="" 
                data-index=""
                title="${title}"
                scrolling="no"></iframe>
        `);
        this.iframe = $(`#${this.id}`);
    }

    setContent(content) {
        Registry.d("Popup.setContent");

        const headRe = /<head>([\s\S]*)<\/head>/gi;
        const bodyRe = /<body>([\s\S]*)<\/body>/gi;
        const head = headRe.exec(content);
        const body = bodyRe.exec(content);
        const $iframe = this.iframe.contents();

        $iframe.find('html').attr('lang', this.html_lang);
        $iframe.find('head').html(head[1]);
        $iframe.find('body').html(body[1]);
    }

    notify(key, val){
        Registry.d("Popup.notify");
        if (this.iframe) {
            if (this.iframe[0]) {
                if (this.iframe[0].contentWindow) {
                    return this.iframe[0].contentWindow.postMessage(JSON.stringify({key, value: val}), '*');
                }
            }
        }
    }

    loadContent(cb){
        let link = this.getLink();

        if(link){
            if (this.content[link]) {
                this.setContent(this.content[link]);
                if (cb) { return cb(this); }
            } else {
                return $.ajax({
                    url: this.getLink(),
                    dataType: "html",
                    success: res=> {
                        this.content[link] = res;
                        this.setContent(res);
                        if (cb) { return cb(this); }
                    }
                });
            }
        }
    }

    show() {
        this.body.css('overflow', 'hidden');
        let ret = this.iframe.show().css(this.options.css);
        this.iframe.focus();
        return ret;
    }

    hide() {
        this.body.css('overflow', '');
        return this.iframe.hide();
    }
}

export default Popup;


// WEBPACK FOOTER //
// ./src/embed/popups/Popup.es6